import {IComponentOptions} from 'angular';

export class StringInputComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        model: '=',
        name: '@',
        inputPattern: '@?',
        label: '@',
        clazz: '@',
        placeholder: '@',
        ngRequired: '<',
        bisherFs: '<?',
        bisherGs: '<?',
        bisherProperty: '@?'
    };
    template = require('./dv-string-input.html');
    controller = DvStringInputController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvStringInputController {

    model?: string;
    name: string;
    inputPattern: string;
    label: string;
    placeholder: string;
    clazz: string;
    ngRequired: boolean;
    bisherFs: any;
    bisherGs: any;
    bisherProperty: string;
    valueRequired: boolean = true; // default required

    constructor() {
    }

    $onInit() {
        if (this.ngRequired !== undefined) {
            this.valueRequired = this.ngRequired;
        }

    }

    public showBisher(): boolean {
        return (this.bisherGs !== undefined && this.bisherFs !== undefined && this.bisherProperty !== undefined)
    }
}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-string-input/dv-string-input.ts